<div class="form-group">
  <label for="comment" class="control-label">Comment</label>
  <textarea
    id="comment"
    class="form-control"
    maxlength="10000"
    rows="5"
    [nasModel]="commentStore"
    [disabled]="disable"
  ></textarea>

  <ng-container *ngIf="samplingStore?.$ | async as samplingStore">
    <p
      *ngIf="samplingStore.comment_last_updated_at"
      class="help-block explanatory muted"
    >
      Last updated by
      {{ samplingStore.comment_last_updated_by!.full_name }} at
      {{ samplingStore.comment_last_updated_at | h3Date }}
    </p>
  </ng-container>
  @if (displayWarningText) {
    <p class="subtitle-03 warning-text">
      Comments are for indicative purposes only, to flag errors please use error
      tags
    </p>
  }
</div>
